// extracted by mini-css-extract-plugin
export default {"btnpwd":"_1d31e260d6"};